export default () => ({
  /**
   * Suites Directory Alpine.js Component
   * Server-rendered HTML with Alpine.js for filtering
   */

  // Filter properties
  selectedSquareFootage: "",
  selectedOfficeType: "",
  selectedBuilding: "",

  // Cached suite rows
  suiteRows: [],

  // Initialize component
  init() {
    // Cache all suite rows for faster filtering
    this.suiteRows = Array.from(this.$el.querySelectorAll(".suite-row"));
    console.log(
      "Suites List initialized with",
      this.suiteRows.length,
      "suites"
    );
  },

  // Check if a suite row should be visible based on current filters
  isVisible(index) {
    const row = this.suiteRows[index];
    if (!row) return false;

    // Square footage filter
    if (this.selectedSquareFootage) {
      const squareFootage = row.dataset.squareFootage || "";
      if (squareFootage !== this.selectedSquareFootage) {
        return false;
      }
    }

    // Office type filter
    if (this.selectedOfficeType) {
      const officeType = row.dataset.officeType || "";
      if (officeType !== this.selectedOfficeType) {
        return false;
      }
    }

    // Building filter
    if (this.selectedBuilding) {
      const building = row.dataset.building || "";
      if (building !== this.selectedBuilding) {
        return false;
      }
    }

    return true;
  },

  // Count of visible suites for no-results message
  get visibleCount() {
    return this.suiteRows.filter((row, index) => this.isVisible(index)).length;
  },
});
